import './styles.css';
import { App } from './app/App';

const raiz = document.getElementById('app');
if (raiz) {
  const app = new App(raiz);
  app.montar().catch((err: unknown) => {
    raiz.textContent = `Cernicalo Online no pudo arrancar: ${err instanceof Error ? err.message : String(err)}`;
    console.error(err);
  });
  (window as unknown as { cernicalo?: App }).cernicalo = app;
}
